<template>
    <section class="appWidth h-screen m-auto bg-secondary text-center p-8 flex flex-col justify-center items-center">
        <h1 class="mb-4 text-8xl tracking-tight font-extrabold text-danger">404</h1>
        <p class="mb-4 text-3xl tracking-tight font-bold text-light">Something's missing</p>
        <p class="mb-5 text-md text-light">ဝမ်းနည်းပါတယ်၊အဲဒီစာမျက်နှာကိုရှာမတွေ့ပါဘူး။ပင်မစာမျက်နှာတွင်စူးစမ်းလေ့လာစရာများစွာကိုတွေ့ရပါမည်။</p>
        <router-link to="/" class="text-white bg-primary font-medium rounded-lg text-sm px-5 py-2.5 text-center">ပင်မစာမျက်နှာသို့ပြန်သွားရန်</router-link>
    </section>
</template>
